module.exports = __webpack_public_path__ + "img/_icon_nuled.08efd595.svg";